<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-body>
                <div id="orders">
                    <b-row>
                        <b-col md="6">
                            <b-form>
                                <b-form-group label="Статус заявки: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                                    <b-form-select id="basicSelect"
                                                   @change="applyStatusFilter()"
                                                   :plain="true"
                                                   v-model="statusFilter"
                                                   :options="getStatusesTV()"
                                                   value="Please select">
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group label="Дата создания: " label-for="rangeSelect" :label-cols="3" :horizontal="false">
                                    <div class="input-group">
                                        <v-date-picker
                                                id="rangeSelect"
                                                mode='range'
                                                v-model='rangeFilter'
                                                @change="applyRangeFilter()"
                                                @input="applyRangeFilter()"
                                        >
                                        </v-date-picker>
                                        <b-button type="button" variant="secondary"  @click='resetRange()'><i class="cui-circle-x icon"></i> </b-button>
                                    </div>
                                </b-form-group>
                            </b-form>
                        </b-col>
                        <b-col align="right">
                            <b-button type="button" size="sm" variant="success"  @click='createOrder(true)'><i class="fa fa-add"></i> Создать общую заявку</b-button> &nbsp;
                            <b-button type="button" size="sm" variant="success"  @click='createOrder()'><i class="fa fa-add"></i> Создать заявку</b-button> &nbsp;
                            <b-button type="button" size="sm" variant="success"  :to="{ path: '/agent/tourhelper' }"><i class="fa fa-add"></i> Подбор туров</b-button> &nbsp;
                            <b-button type="button" size="sm" variant="secondary"  @click='reloadTable()'><i class="fa fa-refresh"></i> Обновить список</b-button>
                        </b-col>
                    </b-row>

                    <v-server-table :url="apiurl('order/table/fc')"  :columns="columns" :options="options" :theme="theme" id="ordersTable" ref="ordersTable" >
                        <div slot="child_row" slot-scope="props">
                            {{props.row.surname_correct}} {{props.row.name_correct}} {{props.row.patro_correct}}
                            <span v-if="namesDiffer(props.row)">
                                <br/>
                                <small>
                                    ({{props.row.surname}} {{props.row.name_}} {{props.row.patro}})
                                </small>
                            </span>
                        </div>
                        <span slot="id" slot-scope="props">
                            <a :href="$router.resolve({ path:orderPage(props.row.id)}).href">{{ props.row.id }}</a>
                            <br><small>{{ CONSTANTS.ORDER_STATUS_NAMES[props.row.status_index] }}</small>
                        </span>
                    </v-server-table>
                    <p><small>при поиске по полям "имя", "e-mail", "телефоны" осуществляется поиск по полному соответствию.
                        Если вам необходим поиск по подстроке, то используйте символ % (процент) в начале и/или в конце поисковой фразы.
                        <br/>
                        Имя, Фамилия и отчество ищутся по-отдельности, поэтому при поиске по имени указывайте только что-то одно.
                    </small></p>
                </div>

            </b-card-body>
        </b-card>
    </div>
</template>

<script>

    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_order } from '@/functions_order.js';
    import VueJsonPretty from 'vue-json-pretty'
    import {CONSTANTS} from '@/constants';
    import m_phone from '../jsx/orders/m_phone'
    import date_create_iso from '../jsx/orders/date_create_iso'
    import fullname from '../jsx/orders/fullname'
    import contacts from '../jsx/orders/contacts'
    import user from '../jsx/orders/user'

    Vue.use(ServerTable)

    const today = new Date()

    export default {
        name: 'NsbAgencyOrders',
        components: {
            ServerTable,
            Event,
            VueJsonPretty,
        },
        mixins: [functions, functions_order],
        data: function () {
            return {
                columns: ['id', 'm_phone', 'date_create_iso', 'fullname', 'contacts', 'user'],
                options: {
                    saveState: true,
                    headings: {
                        id: '#',
                        m_phone: 'флаги',
                        date_create_iso: 'даты',
                        fullname: 'имя (город)',
                        contacts: 'контакты',
                        status_index: 'статус',
                    },
                    sortable: ['id', 'created_at'],
                    filterable: ['id', 'fullname', 'contacts' ],
                    templates: {
                        m_phone,
                        date_create_iso,
                        fullname,
                        contacts,
                        user
                    },
                    customFilters: [
                        'status',
                        'range',
                    ],
                    filterByColumn: true,
                    perPage:10,
                    perPageValues:[],

                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: { chunk: 10, edge: false, nav: 'scroll' },
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    rowClassCallback: this.latestOrderClass,
                },
                theme: 'bootstrap4',
                template: 'default',
                rangeFilter: null,
                statusFilter:null,
            }
        },
        methods: {
            applyStatusFilter: function() {
                this.saveFilter();
                Event.$emit('vue-tables.filter::status', this.statusFilter);
            },
            applyRangeFilter: function() {
                this.saveFilter();
                Event.$emit('vue-tables.filter::range', this.rangeString);
            },
            resetRange: function() {
                this.rangeFilter = null;
                this.saveFilter();
                Event.$emit('vue-tables.filter::range', null);
            },
            getStatuses: function(){
                return CONSTANTS.ORDER_STATUS_NAMES;
            },
            getStatusesTV: function(){
                let statusTV = [];
                for(let i=0; i<CONSTANTS.ORDER_STATUS_NAMES.length; i++) {
                    statusTV.push({text:CONSTANTS.ORDER_STATUS_NAMES[i], value:i});
                }
                return statusTV;
            },

            reloadTable: function() {
                var table = this.$refs.ordersTable;
                table.getData();
            },
            saveFilter() {
                this.$store.commit('saveOrderFilters', {
                    statusFilter:this.statusFilter,
                    rangeFilter:this.rangeFilter,
                });
            },

            restoreFilter() {
                this.statusFilter = this.$store.state.orderFilters.statusFilter;
                if (!this.statusFilter) this.statusFilter=null;

                this.rangeFilter = Object.assign({}, this.$store.state.orderFilters.rangeFilter);
                if (!this.rangeFilter) this.rangeFilter=null;

                var table = this.$refs.ordersTable;
                table.customQueries.range = this.rangeString;
                table.customQueries.status = this.statusFilter;
                table.getData();
            }

        },
        computed: {
            rangeStart: function () { return new Date(this.rangeFilter.start).toLocaleDateString() },
            rangeEnd: function () { return new Date(this.rangeFilter.end).toLocaleDateString() },
            rangeString: function () {
                if (this.rangeFilter !== null)
                    return (new Date(this.rangeFilter.start).toLocaleDateString()) + '_' + (new Date(this.rangeFilter.end).toLocaleDateString())
                return null;
            },
        },
        created: function() {
        },
        mounted: function() {
            this.restoreFilter();
        },

        notifications: {
            showMessageOrderCreated: {
                type: 'success',
                title: 'Заявка создана',
                message: 'Заявка была успешно создана, теперь вы можете перейти к ее редактированию'
            },
        }
    };
</script>

<style lang="scss">
</style>
